import React from 'react'
import s from './TextError.less'

import { selectLocale } from '../../store/navigation/navigation.selectors'
import { translate } from '../i18n/T'
import { useSelector } from 'react-redux'
import { isString } from '../../utils/string'

export const defaultErrorMessage = 'Erreur'

const getMessage = ({ error, locale }) => {
  if (isString(error)) return error
  const errorName = error?.name
  if (errorName) {
    const translatedMessage = translate(locale)(errorName)
    if (translatedMessage !== errorName) return translatedMessage
  }
  return error?.message ?? defaultErrorMessage
}

export const TextError = ({ error }) => {
  const locale = useSelector(selectLocale)

  if (!error) return <></>

  return (
    <div className={s.TextError}>
      <span className={s.TextErrorMessage}>{getMessage({ error, locale })}</span>
    </div>
  )
}

export default TextError
